// @flow

import { observer } from "mobx-react";
import React from "react";
import ToggleButton from "react-toggle-button";

import User from "app/models/User";

import AppearanceStore from "app/stores/AppearanceStore";
import UserStore from "app/stores/UserStore";

import Panel from "app/components/Panel/Panel";
import PageTitle from "app/components/PageTitle/PageTitle";
import Icon from "app/components/Icon/Icon";

import "./DashboardPreferencesView.scss";

type Props = {
    user: User
};

type State = {
    darkTheme: boolean,
    autoplay: boolean,
    timeline_thumbnails: boolean,
};

@observer
export default class DashboardPreferencesView extends React.Component<
    Props,
    State
> {
    user: User;

    constructor(opts: any) {
        super(opts);

        const user = User.make(this.props.user);
        if (!user) throw Error("User must be logged in");
        this.user = user;

        this.state = {
            darkTheme: user.theme === "dark",
            autoplay: user.autoplay,
            timeline_thumbnails: user.timeline_thumbnails,
        };
    }

    handleDarkTheme = () => {
        const enabled = !this.state.darkTheme;
        this.setState({ darkTheme: enabled });

        UserStore.updatePreference("theme", enabled ? "dark" : "white");
        this.toggleDOMDarkTheme(enabled);
    };

    toggleDOMDarkTheme(enabled: boolean) {
        const theme = enabled ? "dark" : "white";
        AppearanceStore.setTheme(theme);
    }

    handleAutoPlay = () => {
        const enabled = !this.state.autoplay;

        this.setState({ autoplay: enabled });
        UserStore.updatePreference("autoplay", enabled);
    };

    handleTimelineThumbnails = () => {
        const enabled = !this.state.timeline_thumbnails;
        this.setState({ timeline_thumbnails: enabled });
        UserStore.updatePreference("timeline_thumbnails", enabled);
    };

    render() {
        return (
            <div className="DashboardPreferencesView">
                <Panel>
                    <PageTitle>
                        <Icon name="cog" /> Preferences
                    </PageTitle>

                    <div className="UserPreferencesView__list">
                        {this.renderDarkTheme()}
                        {this.renderAutoPlay()}
                        {this.renderHideTimeline()}
                    </div>
                </Panel>
            </div>
        );
    }

    renderDarkTheme() {
        return (
            <div className="UserPreferencesView__option">
                <h3 className="UserPreferencesView__option-title">
                    Dark Theme
                </h3>
                <p>Set to ON to use Dark Theme</p>
                <ToggleButton
                    value={this.state.darkTheme}
                    onToggle={this.handleDarkTheme}
                />
            </div>
        );
    }

    renderAutoPlay() {
        return (
            <div className="UserPreferencesView__option">
                <h3 className="UserPreferencesView__option-title">
                    Video Autoplay
                </h3>
                <p>Set to ON to enable video autoplay</p>
                <ToggleButton
                    value={this.state.autoplay}
                    onToggle={this.handleAutoPlay}
                />
            </div>
        );
    }

    renderHideTimeline() {
        return (
            <div className="UserPreferencesView__option">
                <h3 className="UserPreferencesView__option-title">
                    Show Timeline Thumbnails
                </h3>
                <p>Set to ON to show thumbnails of your timeline objects</p>
                <ToggleButton
                    value={this.state.timeline_thumbnails}
                    onToggle={this.handleTimelineThumbnails}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/dashboard/DashboardPreferences/DashboardPreferencesView.js